import { cloneDeep, compact, isEmpty, isNumber, find, get, map, set } from 'lodash-es';
import uuidv4 from 'uuid/v4';
import { checkIsEmpty } from '../../utils';

import { getQuestionnaireSalesrouteByIdQuestionnaire } from '../../utils';

/**
 * get question
 * @param extraData
 */
const getQuestionGroup = extraData => ({
  code: get(extraData, 'code'),
  sequence: get(extraData, 'sequence'),
});

const handleQuestionGroup = group => {
  let questions = [];

  // from web service
  if (!isEmpty(get(group, 'extra_data'))) {
    questions = map(get(group, 'extra_data'), extraData => getQuestionGroup(extraData));
  }

  // from store
  if (!isEmpty(get(group, 'questions'))) {
    questions = [...questions, ...map(get(group, 'questions'), question => getQuestionGroup(question))];
  }

  return questions;
};

/**
 * get group
 * @param group
 */
const getGroup = group => ({
  ...group,
  id: !checkIsEmpty(get(group, 'id')) ? group.id : uuidv4(),
  questions: handleQuestionGroup(group),
  // todo verify reel case
  groups: !isEmpty(get(group, 'groups')) ? map(get(group, 'groups'), groupItem => getGroup(groupItem)) : undefined,
});

/**
 * get question
 * @param {*} question
 */
const getQuestion = (question, answerValue) => {
  try {
    let validation = [];

    if (!isEmpty(get(question, 'validation'))) {
      validation = get(question, 'validation');
    }

    if (question.required) {
      validation.push({ required: true, message: ' ' /* 'champ obligatoire' */ }); // HACK demo to not display error message
    }

    const result = {
      ...question,
      value: answerValue,
      validation,
    };
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getPart ${e.stack}`);
  }
  return undefined;
};

/**
 * get answer value
 * @param {} answersQuestion
 * @param {} questionItem
 */
const getAnswerValue = (answersQuestion, questionItem) => {
  let answerValue;

  if (get(questionItem, 'path.path')) {
    answerValue = get(answersQuestion, `${get(questionItem, 'path.root')}.${get(questionItem, 'path.path')}`);
  } else {
    answerValue = get(answersQuestion, questionItem.code);
  }

  // Force convert number to string for selection field because Formik transform it to string...
  if (questionItem.type === 'selection' && isNumber(answerValue)) {
    answerValue = `${answerValue}`;
  }

  return answerValue;
};

/**
 * get part
 * @param part
 */
const getPart = (part, answersQuestion) => {
  try {
    const questions = map(get(part, 'questions'), questionItem => {
      const question = getQuestion(questionItem, getAnswerValue(answersQuestion, questionItem));
      return question;
    });
    const groups = !isEmpty(get(part, 'groups')) ? map(get(part, 'groups'), group => getGroup(group)) : undefined;

    const result = {
      ...part,
      questions,
      groups,
    };

    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getPart ${e.stack}`);
  }
  return undefined;
};

/**
 *
 * @param {*} answersParts
 * @param {*} part
 */
const getAnswersQuestions = (part, answersParts) => {
  try {
    const answersPart = find(answersParts, { id: get(part, 'id') });
    const answersQuestions = get(answersPart, 'answers');
    return answersQuestions;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getAnswersQuestions ${e.stack}`);
  }
  return undefined;
};

/**
 * get block loan
 * @param block
 */
const getBlock = (block, salesRoute, answersParts) => {
  try {
    const parts = map(get(block, 'parts'), partItem => {
      const answersQuestions = getAnswersQuestions(partItem, answersParts);
      const part = getPart(partItem, answersQuestions);
      return part;
    });

    let title = '';
    if (get(answersParts, '[0].answers.parties.first_name')) {
      title += `${answersParts[0].answers.parties.first_name}`;
    }
    if (get(answersParts, '[0].answers.parties.name')) {
      if (title.length) title += ' ';
      title += `${answersParts[0].answers.parties.name}`;
    }

    const result = {
      ...block,
      title: { default: title },
      id: `${answersParts[0].answers.parties.ref}_block`,
      displayTitle: get(block, 'displayTitle', true),
      parts,
    };

    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getBlock ${e.stack}`);
  }
  return undefined;
};

/**
 *  get answers
 * @param {*} salesRoute
 */
const getAnswers = (salesRoute, contract) => {
  try {
    const parties = find(get(salesRoute, 'parties', []), { ref: contract.subscriber.ref });
    const answers = { contract, parties };
    const parts = [{ id: 1, answers }];

    const answersFinal = { id: contract.subscriber.ref, parts };
    return answersFinal;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return undefined;
};

/**
 *
 * @param {*} param0
 */
const subscriptionBlockTransform = ({ salesRoute }) => {
  try {
    const idQuestionnaire = get(salesRoute, 'questionnaires[0].questionnaire.id');
    const questionnaireSalesRoute = getQuestionnaireSalesrouteByIdQuestionnaire({
      salesroute: salesRoute,
      idQuestionnaire,
    });

    const subscriptionBlock = get(questionnaireSalesRoute, 'description.subscription_block');

    const subBlocks = compact(
      map(get(salesRoute, 'contracts', []), (contract, idx) => {
        const answers = getAnswers(salesRoute, contract);

        if (!answers.parts[0].answers.parties) {
          console.error('Why no party at this step?!');
          set(answers, 'parts[0].answers.parties', {});
        }

        // const isReady = questionnaireBlockIsReady({ questionnaire });

        // if (!isReady) {
        //   // eslint-disable-next-line no-console
        //   return {};
        // }

        let subBlock;

        if (subscriptionBlock.standard) {
          subBlock = cloneDeep(subscriptionBlock.standard);
        } else if (subscriptionBlock.pp && subscriptionBlock.pm) {
          if (answers.parts[0].answers.parties.is_person) {
            subBlock = cloneDeep(subscriptionBlock.pp);
          } else {
            if (idx) return undefined;

            subBlock = cloneDeep(subscriptionBlock.pm);
          }
        }

        // build block
        return getBlock(subBlock, salesRoute, get(answers, 'parts'));
      })
    );

    const result = { subscribers: subBlocks };

    if (subscriptionBlock?.selectPersonType) {
      // Add selection of Type de souscripteur (Personne physique/personne morale)
      const firstPartie = find(salesRoute.parties, { ref: get(salesRoute, 'contracts[0].subscriber.ref') });
      const part = getPart(subscriptionBlock.selectPersonType.parts[0], { partie: firstPartie });

      result.subscribers = [{ ...subscriptionBlock.selectPersonType, parts: [part] }, ...subBlocks];
    }

    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`questionnaireBlockTransform: ${e.stack}`);
  }

  return {};
};

export default subscriptionBlockTransform;
